/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterScopeDto } from './EvaluationParameterScopeDto';
import {
    EvaluationParameterScopeDtoFromJSON,
    EvaluationParameterScopeDtoFromJSONTyped,
    EvaluationParameterScopeDtoToJSON,
} from './EvaluationParameterScopeDto';
import type { MedicalSystemSetupBaseDto } from './MedicalSystemSetupBaseDto';
import {
    MedicalSystemSetupBaseDtoFromJSON,
    MedicalSystemSetupBaseDtoFromJSONTyped,
    MedicalSystemSetupBaseDtoToJSON,
} from './MedicalSystemSetupBaseDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { TaskItemAreaDtoInstruction } from './TaskItemAreaDtoInstruction';
import {
    TaskItemAreaDtoInstructionFromJSON,
    TaskItemAreaDtoInstructionFromJSONTyped,
    TaskItemAreaDtoInstructionToJSON,
} from './TaskItemAreaDtoInstruction';
import type { TaskItemQaEquipmentSetupDto } from './TaskItemQaEquipmentSetupDto';
import {
    TaskItemQaEquipmentSetupDtoFromJSON,
    TaskItemQaEquipmentSetupDtoFromJSONTyped,
    TaskItemQaEquipmentSetupDtoToJSON,
} from './TaskItemQaEquipmentSetupDto';

/**
 * 
 * @export
 * @interface TaskItemAreaDto
 */
export interface TaskItemAreaDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemAreaDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskItemAreaDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    name?: string | null;
    /**
     * 
     * @type {MedicalSystemSetupBaseDto}
     * @memberof TaskItemAreaDto
     */
    medicalSystemSetup?: MedicalSystemSetupBaseDto;
    /**
     * 
     * @type {Array<TaskItemQaEquipmentSetupDto>}
     * @memberof TaskItemAreaDto
     */
    qaEquipmentSetups?: Array<TaskItemQaEquipmentSetupDto> | null;
    /**
     * 
     * @type {TaskItemAreaDtoInstruction}
     * @memberof TaskItemAreaDto
     */
    instruction?: TaskItemAreaDtoInstruction | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    readonly combinationSetId?: string;
    /**
     * 
     * @type {Array<EvaluationParameterScopeDto>}
     * @memberof TaskItemAreaDto
     */
    evaluationScopes?: Array<EvaluationParameterScopeDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemAreaDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof TaskItemAreaDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemAreaDto
     */
    $type?: TaskItemAreaDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemAreaDtoTypeEnum = typeof TaskItemAreaDtoTypeEnum[keyof typeof TaskItemAreaDtoTypeEnum];


/**
 * Check if a given object implements the TaskItemAreaDto interface.
 */
export function instanceOfTaskItemAreaDto(value?: unknown): value is TaskItemAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemAreaDtoTypeEnum)[0];
}

export function TaskItemAreaDtoFromJSON(json: any): TaskItemAreaDto {
    return TaskItemAreaDtoFromJSONTyped(json, false);
}

export function TaskItemAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'medicalSystemSetup': !exists(json, 'medicalSystemSetup') ? undefined : MedicalSystemSetupBaseDtoFromJSON(json['medicalSystemSetup']),
        'qaEquipmentSetups': !exists(json, 'qaEquipmentSetups') ? undefined : (json['qaEquipmentSetups'] === null ? null : (json['qaEquipmentSetups'] as Array<any>).map(TaskItemQaEquipmentSetupDtoFromJSON)),
        'instruction': !exists(json, 'instruction') ? undefined : TaskItemAreaDtoInstructionFromJSON(json['instruction']),
        'combinationSetId': !exists(json, 'combinationSetId') ? undefined : json['combinationSetId'],
        'evaluationScopes': !exists(json, 'evaluationScopes') ? undefined : (json['evaluationScopes'] === null ? null : (json['evaluationScopes'] as Array<any>).map(EvaluationParameterScopeDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskItemAreaDtoToJSON(value?: TaskItemAreaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'name': value.name,
        'medicalSystemSetup': MedicalSystemSetupBaseDtoToJSON(value.medicalSystemSetup),
        'qaEquipmentSetups': value.qaEquipmentSetups === undefined ? undefined : (value.qaEquipmentSetups === null ? null : (value.qaEquipmentSetups as Array<any>).map(TaskItemQaEquipmentSetupDtoToJSON)),
        'instruction': TaskItemAreaDtoInstructionToJSON(value.instruction),
        'evaluationScopes': value.evaluationScopes === undefined ? undefined : (value.evaluationScopes === null ? null : (value.evaluationScopes as Array<any>).map(EvaluationParameterScopeDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        '$type': value.$type,
    });
}

